import { useEffect, useState, useMemo } from "react";
import { Typography } from "@material-tailwind/react";
import jsonData from "../KS.json";

const PRAYER_ICONS = {
  sabahu: "iconsTakvim/sabahu.png",
  sunrise: "iconsTakvim/sunrise.png",
  dreka: "iconsTakvim/dreka.png",
  ikindia: "iconsTakvim/ikindia.png",
  sunset: "iconsTakvim/sunset.png",
  jacia: "iconsTakvim/jacia.png",
};

const PRAYER_NAMES = {
  sabahu: "Sabahu",
  sunrise: "Lindja e diellit",
  dreka: "Dreka",
  ikindia: "Ikindia",
  sunset: "Akshami",
  jacia: "Jacia",
};

function parseTime(timeStr) {
  const [hours, minutes] = timeStr.split(":");
  const time = new Date();
  time.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
  return time;
}

const Countdown = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  const prayerTimes = useMemo(() => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentDay = currentDate.getDate();

    const prayerTime = jsonData.find(
      (data) => data.Month === currentMonth && data.Date === currentDay
    );

    if (!prayerTime) return null;

    const imsakuTime = parseTime(prayerTime.Imsaku);
    const sabahuTime = new Date(imsakuTime.getTime() + 30 * 60000);

    return {
      sabahu: sabahuTime,
      sunrise: parseTime(prayerTime["Lindja e diellit"]),
      dreka: parseTime(prayerTime.Dreka),
      ikindia: parseTime(prayerTime.Ikindia),
      sunset: parseTime(prayerTime.Akshami),
      jacia: parseTime(prayerTime.Jacia),
      currentDay,
      sabahuTime,
    };
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const getDisplayTime = () => {
    if (!prayerTimes) return null;

    const { sabahu, sunrise, dreka, ikindia, sunset, jacia, currentDay, sabahuTime } = prayerTimes;

    if (currentTime <= sabahu) {
      return { time: sabahu, key: "sabahu" };
    } else if (currentTime <= sunrise) {
      return { time: sunrise, key: "sunrise" };
    } else if (currentTime <= dreka) {
      return { time: dreka, key: "dreka" };
    } else if (currentTime <= ikindia) {
      return { time: ikindia, key: "ikindia" };
    } else if (currentTime <= sunset) {
      return { time: sunset, key: "sunset" };
    } else if (currentTime <= jacia) {
      return { time: jacia, key: "jacia" };
    } else {
      // Check if it's between Jaci and Sabahu
      const nextDaySabahu = new Date(currentTime);
      nextDaySabahu.setDate(currentDay + 1);
      nextDaySabahu.setHours(
        sabahuTime.getHours(),
        sabahuTime.getMinutes(),
        0,
        0
      );
      return { time: nextDaySabahu, key: "sabahu" };
    }
  };

  const nextPrayer = getDisplayTime();
  const nextPrayerTime = nextPrayer?.time;

  const getPrayerName = (key) => {
    return (
      <div className="flex items-center gap-1.5 sm:gap-3">
        <img src={PRAYER_ICONS[key]} alt={PRAYER_NAMES[key]} width={32} height={32} className="sm:w-10 sm:h-10" />
        <Typography variant="h4" color="blue-gray" className="normal-case">
          {PRAYER_NAMES[key]}
        </Typography>
      </div>
    );
  };

  const getTimeRemaining = () => {
    if (!nextPrayerTime) {
      return { hours: "00", minutes: "00", seconds: "00" };
    }

    const timeDiff = nextPrayerTime.getTime() - currentTime.getTime();
    const totalSeconds = Math.floor(timeDiff / 1000);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return {
      hours: String(hours).padStart(2, "0"),
      minutes: String(minutes).padStart(2, "0"),
      seconds: String(seconds).padStart(2, "0"),
    };
  };

  const { hours, minutes, seconds } = getTimeRemaining();

  if (!nextPrayer) {
    return null;
  }

  return (
    <div className="flex flex-col items-center gap-2 w-full">
      <div className="flex items-center gap-2 justify-center">
        {getPrayerName(nextPrayer.key)}
      </div>
      <div className="text-center flex items-center justify-center gap-1.5 sm:gap-2">
        <Typography variant="h4" color="blue-gray" className="normal-case">
          edhe:
        </Typography>
        <Typography variant="h4" color="blue-gray" className="font-mono w-[100px] sm:w-[115px] text-center">
          {hours}:{minutes}:{seconds}
        </Typography>
      </div>
    </div>
  );
};

export default Countdown;
